import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const sendOTP = createAsyncThunk("GET_SUMMARY_API", async (userdata) => {
  let config = {
    headers: {
      "Content-Type": "application/json",
    },
  };

  try {
    const response = await axios.get(
      `${API_BASE_URL}/otp/sendOtp?username=${userdata}&url=expert.phybercare.com`,

      config
    );
    let status = "success";
    let data_res = {
      status: status,
      message: response,
    };
    return data_res;
  } catch (error) {
    let status = "error";
    let data_error = {
      status: status,
      message:
        error.response?.data || "Something went wrong, please try again.",
    };
    return data_error;
  }
});

const SendOTPSlice = createSlice({
  name: "GET_SUMMARY_SLICE",
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(sendOTP.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(sendOTP.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(sendOTP.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default SendOTPSlice.reducer;
